import React from 'react';
import Task from './Task';
import User from './User';
import Article from './Article';
import Location from './Location';
import Container from './Container';
import Order from './Order';
import RawMaterial from './RawMaterial';
import Recipe from './Recipe';
import Action from './Action';
import Work from './Work';
import Customer from './Customer';
import style from './style.scss';

class Tag extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (this.props.type === 'user') { return <User {...this.props} />; }
    if (this.props.type === 'task') { return <Task {...this.props} />; }
    if (this.props.type === 'location') { return <Location {...this.props} />; }
    if (this.props.type === 'article') { return <Article {...this.props} />; }
    if (this.props.type === 'container') { return <Container {...this.props} />; }
    if (this.props.type === 'order') { return <Order {...this.props} />; }
    if (this.props.type === 'rawMaterial') { return <RawMaterial {...this.props} />; }
    if (this.props.type === 'recipe') { return <Recipe {...this.props} />; }
    if (this.props.type === 'action') { return <Action {...this.props} />; }
    if (this.props.type === 'work') { return <Work {...this.props} />; }
    if (this.props.type === 'customer') { return <Customer {...this.props} />; }
    return (
      <div className={[style.tag, this.props.className].join(' ')} onClick={e => { e.preventDefault(); e.stopPropagation(); }}>
        Unknown tag
      </div>
    );
  }
}

export default Tag;



// WEBPACK FOOTER //
// ./app/components/Tag/index.js